import * as BABYLON from "@babylonjs/core/Legacy/legacy";

import { config } from "../config.js";
import { IMeshPool } from "./common.js";
import { GameScene } from "../scene";

const log = console.log.bind(console);

export class CoinMeshPool implements IMeshPool {
	meshes: BABYLON.Mesh[];
	scene: GameScene;

	constructor(scene: GameScene) {
		this.meshes = [];
		this.scene = scene;
		this.createMeshes();
	}

	createMeshes() {
		let scene = this.scene;

		// 金币动画
		let frameRate = 1;
		let ani = new BABYLON.Animation(
			"coin_rotate",
			"rotation.y",
			frameRate,
			BABYLON.Animation.ANIMATIONTYPE_FLOAT,
			BABYLON.Animation.ANIMATIONLOOPMODE_CYCLE,
		);
		let keys = [
			{ frame: 0, value: 0 },
			{ frame: frameRate * 5, value: Math.PI * 2 },
		];
		ani.setKeys(keys);

		// 金币 mesh
		const createCoinMesh = function () {
			const mesh = BABYLON.MeshBuilder.CreateCylinder("cylinder", {
				diameter: 0.1,
				height: 0.005,
				// diameter: 0.8,
				// height: 0.04,
			});
			const mat = new BABYLON.StandardMaterial(
				"myMaterial",
				scene.bbScene,
			);
			mat.diffuseColor = new BABYLON.Color3(1, 1, 1);
			// mat.diffuseColor = new BABYLON.Color3(1, 1, 1);
			mat.diffuseTexture = scene
				.GetAsset()
				.loadTexture("./assets/yellow_noise_texture.jpeg");
			mat.bumpTexture = scene
				.GetAsset()
				.loadTexture("./assets/axe5_map.png");
			mat.emissiveColor = new BABYLON.Color3(0.3, 0.3, 0);

			mesh.material = mat;
			mesh.position.y = config.groundHeight;

			mesh.isVisible = false;
			// cylinder.position.z += 0.5
			// cylinder.position.x += 0.2

			mesh.rotation.x -= Math.PI / 2;

			return mesh;
		};

		var gl = new BABYLON.GlowLayer("glow", scene.bbScene, {
			mainTextureFixedSize: 128,
			blurKernelSize: 32,
		});
		gl.intensity = 0.4;

		for (let i = 0; i < config.coinPreloadNum; i++) {
			let mesh = createCoinMesh();
			// 限制这个 glow shader 叠加效果只对金币生效
			gl.addIncludedOnlyMesh(mesh);
			this.meshes.push(mesh);
		}
	}

	getMesh(): BABYLON.Mesh {
		let res = this.meshes.pop();
		res.isVisible = true;
		return res;
	}

	returnMesh(mesh: BABYLON.Mesh) {
		mesh.isVisible = false;
		mesh.position.y = -10;
		this.meshes.push(mesh);
	}
}
